// const server = process.env.REACT_APP_SERVER_URL || "http://localhost:8000";
const server = "https://quickcall-yam6.onrender.com";


export default server;
